/**
 * @TODO Alex no way we keep that
 */
export const FEATURES_BY_PRODUCT = {
  common: [
    'Transactions reporting', 'MyTax reporting', 'Spare Tank', 'Invite Accountant/Advisor', 'Tax Summary'
  ],
  'Sole Tank': [
    'Invite Accountant/Advisor', 'Spare Tank', 'Bank Feeds', 'Tax Summary',
    'Vehicle reporting', 'General Pool reporting', 'Depreciation reporting', 'Business schedule reporting', 'Transactions reporting', 'MyTax reporting'
  ],
  'Work Tank': [
    'Invite Accountant/Advisor', 'Spare Tank', 'Bank Feeds', 'Tax Summary',
    'Vehicle reporting', 'Depreciation reporting', 'LVP reporting', 'Transactions reporting', 'MyTax reporting'
  ],
  'Property Tank': [
    'Invite Accountant/Advisor', 'Dashboard (Property)', 'Spare Tank', 'Bank Feeds', 'Tax Summary',
    'Property Schedules reporting', 'Depreciation reporting', 'CGT reporting', 'LVP reporting', 'Transactions reporting', 'Invite Co-owner', 'MyTax reporting'
  ],
  'Holdings Tank': [
    'Invite Accountant/Advisor', 'Spare Tank', 'Tax Summary', 'CGT reporting'
  ],
  'Money Tank': [
    'Invite Accountant/Advisor', 'Money Tank Dashboard', 'Spare Tank', 'Bank Feeds', 'Income & Expense budgets', 'Budget vs Actuals graphs',
    'Variations Report', 'Budgeting Calendar', 'Goals (Savings, Debt & Equity)', 'Transaction Report',
    'Income & Expense Report', 'Net Assets Report',
  ]
};

export const ALL_FEATURES = ['Invite Accountant/Advisor',  'Money Tank Dashboard', 'Dashboard (Property)',
  'Spare Tank', 'Bank Feeds', 'Tax Summary', 'Property Schedules reporting',
  'Vehicle reporting', 'General Pool reporting', 'Depreciation reporting',  'CGT reporting',
  'LVP reporting', 'Business schedule reporting', 'Transactions reporting', 'Invite Co-owner', 'MyTax reporting',
  'Income & Expense budgets', 'Budget vs Actuals graphs', 'Variations Report', 'Budgeting Calendar',
  'Goals (Savings, Debt & Equity)', 'Transaction Report', 'Income & Expense Report', 'Net Assets Report'];
